module.exports = __webpack_public_path__ + "img/bridge.79549144.png";